import { createSelector } from "reselect";
import { eventHandler } from "../../store/EventHandler";
import { ICanvasEditorState } from "../interfaces/model/CanvasEditorState";
import { CanvasMode } from "../interfaces/model/enumerations/index";

/**
 * Get current canvas mode from CanvasEdit state.
 * @param state {ICanvasEditorState} - The redux state
 * @returns {CanvasMode} Current canvas mode.
 */
const _getCurrentCanvasMode = (state: ICanvasEditorState): CanvasMode =>
	state.canvasEditor.mode;

/**
 * Get selected objects from page
 * @param page {IPage} - Current selected page
 * @param objectIndices {number[]} - selectd objects indices
 * @returns {T[] | null} Object with selected objects array or null
 */
const _getCanvasMode = (mode: CanvasMode): CanvasMode => {
	eventHandler.emit("onModeChange", mode);
	return mode;
};

export const getCanvasMode = createSelector([_getCurrentCanvasMode], _getCanvasMode);
